// extracted by mini-css-extract-plugin
module.exports = {"buttons":"AddMemberPage_buttons__2yTWx","submitContent":"AddMemberPage_submitContent__1XAug","submitText":"AddMemberPage_submitText__3SCmE"};